import { ISearchPage } from "@/types/AppTypes";

//详情
export interface ICceDetail {
	id: string; //4a715593e6567faddc76aadc38887c41"
	code: string; //信用证号
	bentityName: string; //实体名称
	bentityCode: string; //实体编码
	saleCode: string; //外贸合同号
	saleRealCode: string;//自定义外贸合同号
	confirmTime: string | undefined; //到证日期
	signingTime: string | undefined; //签发日期
	currency: string; //币种
	amount: number; //开证金额
	informTime: string | undefined; //通知日期
	sailSchedule: string | undefined; //最迟船期
	creditType: string; //信用证类型
	presentationTime: string | undefined; //交单日期
	isReceipt: number; //是否收汇
	receiptPrice: number; //收汇金额
	receiptTime: string | undefined; //收汇日期
	shopName: string; //云湖门店
	shopCode: string; //SHOP-M-00000102
	opener: string; //开证人
	description: string; //品名描述
	issuingBank: string; //开证银行
	consignee: string; //收货人
	beneficiary: string; //受益人
	payer: string; //汇票人
	draftAt: number; //汇票期限
	negotiationBank: string; //协议银行
	shipment: string; //装货港
	discharge: string; //卸货港
	bearer: string; //提单抬头人
	ladingNotifier: string; //提单通知人
	note: string; //备注
	deleteFlag: number; //
	createTime: string; //2022-05-21T16:00:12
	updateTime: string; //2022-05-21T16:00:08
	createUser: string; //管理员
	relevanceOrderId: string;
}

//询价单商品详情
export interface ICceMaterialDetail {
	key: string,  //自己用
	price?: string | number,  //供应商报价用
	"id"?: string,   // "询价单详情id",
	"inquiryOrderId"?: string,   // "询价单code",
	"code"?: string,   // "询价单code",
	"materialId"?: string,   // "物料id",
	"materialCode"?: string,   // "物料编号",
	"replaceCode"?: string,   // "替换号",
	"materialName"?: string,   // "物料名称",
	"materialEname"?: string,   // "物料名称",
	"typeCode"?: string,   // "物料类型",
	"typeName"?: string,   // "物料类型名称",
	"num"?: string | number,   // "询价数量",
	"model"?: string,   // "规格",
	"note"?: string,   // "备注"
	"isOffer"?: string,   // "是否报价"
	[key: string]: any
}

//新增
export interface ICceInsert extends ICceDetail {

}

//编辑
export interface ICceUpdate extends ICceInsert {
	id: string,
}

//搜索条件
export interface ICceSearchFields {
	"code"?: string,   // "询价单好",
	"customerName"?: string,   // "客户名称",
	"shopCode"?: string,   // "门店Code",
	"status"?: string,   // "状态"
}

export interface ICceSearch
	extends ICceSearchFields, ISearchPage {

}


/**
 * 详情
 */
//tab枚举
export enum ICceTabEnum {
	BASE_DETAIL = "base_detail",  //询价详情
	SUPPLIER_PRICE = "supplier_price", //供应商报价
	RELEVANCE_TASK = "relevance_task", //关联单据
	FILES = "files"   //附件管理
}

/**
 * 出口信用证枚举
 */

export enum ICreditCardTabEnum {
	BASE_DETAIL = "base_detail",  // 基本信息
	RELATED_PERSON = "retaled-person", //关系人
	FILES = "files"   //附件管理
}

/*************供应商报价****************/
export interface ISupplierPriceDialog {
	visible: boolean,
	mode: 'add' | 'edit'
}

//供应商报价详情
export interface ISupplierOfferDetails {
	id: string,
	"shopCode"?: string,  // "code",
	"shopName"?: string,  // "门户名称",
	"inquiryOrderCode"?: string,  // "1",
	"supplierId"?: string,  // "供应商id",
	"supplierCode"?: string,  // "SUP-M-00000414",
	"supplierName"?: string,  // "供应商名称",
	"contact"?: string,  // "联系人",
	"phone"?: string,  // "电话",
	"code"?: string,  // "电话",
	"status"?: string,  // "反馈日期",
	details?: ISupplierMaterialDetails[]
}

//供应商报价商品详情
export interface ISupplierMaterialDetails {
	key?: string,
	id?: string,
	"inquiryOrderDetailsId"?: string,    // "询价单详情id",
	"materialCode"?: string,    // "物料编号",
	"replaceCode"?: string,    // "替换号",
	"materialName"?: string,    // "物料名称",
	"materialEname"?: string,    // "物料名称",
	"typeCode"?: string,    // "物料类型",
	"typeName"?: string,    // "物料类型名称",
	"num"?: string | number,    // 5,
	"price"?: string | number,    // 99,
	"amount"?: string | number,    // 99,
	"model"?: string,    // "规格",
	"note"?: string,    // "备注"
	createTime?: string,
	createUser?: string,
	deleteFlag?: string,
	updateTime?: string,
	updateUser?: string,
	giftsNum?: string,
}

//供应商报价新增
export interface ISupplierOfferInsert extends ISupplierOfferDetails {
	"inquiryOrderCode"?: string,
}

//供应商报价编辑
export interface ISupplierOfferUpdate extends ISupplierOfferInsert {
	id: string,
}

//搜索条件
export interface ISupplierOfferSearchFields {

}

export interface ISupplierOfferSearch
	extends ISupplierOfferSearchFields, ISearchPage {

}